<div class="govuk-form-group">

    <!-- <h1 class="govuk-label-wrapper">
        <label class="govuk-label govuk-label--l" for="event-name">
            Add 
        </label>
    </h1> -->
    <div class="govuk-checkboxes__item">
        <input class="govuk-checkboxes__input" id="waste-2" name="waste" type="checkbox" value="mines"
            [(ngModel)]="diy">
        <label class="govuk-label govuk-checkboxes__label" for="waste-2">
            DIY Waste?
        </label>
        <input class="govuk-input" id="event-name" name="eventName" type="text" [(ngModel)]="reg" (ngModelChange)="reg = reg.toUpperCase()"
            style="width: 30%; margin-right: 4px;">
        <label class="govuk-label govuk-checkboxes__label" for="waste-2">
            Vehicle reg
        </label>
        <button class="govuk-button" data-module="govuk-button" (click)="submitNoBooking()" [disabled]="reg === ''">
            Submit
        </button>
    </div>
    <br>
    <div class="govuk-grid-column-one-half" style="padding: 0px;">
        <div class="govuk-grid-row">
            <div class="govuk-grid-column-one-third">
                <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--l" for="search-field">
                        Search
                    </label>
                </h1>
            </div>

            <div class="govuk-grid-column-one-half">
                <input class="govuk-input" id="event-name" name="search-field" type="text" [(ngModel)]="searchText"
                    (ngModelChange)="search()">
            </div>
        </div>
    </div>
    <div class="govuk-grid-column-one-quarter">
        <br>
    </div>
    <div class="govuk-grid-column-one-quarter">
        <span>
            <button class="govuk-button govuk-button--secondary" data-module="govuk-button" (click)="refresh()">
                Refresh
            </button>
            <!-- <button (click)="this.params = ''">debug</button> -->

        </span>
    </div>

    <div class="govuk-grid-column">

        <table *ngIf="this.noBookings" class="govuk-table" style="table-layout: fixed; width:100%">
            <thead class="govuk-table__head">
                <tr class="govuk-table__row">
                    <ng-container *ngFor="let tab of tableData.tabs;">
                        <th class="govuk-table__header" [ngStyle]="tab.width && {'width': tab.width+'%'}">
                            {{tab.heading}}
                        </th>
                    </ng-container>
                </tr>
                <ng-container *ngFor="let bookingDetails of noBookings; index as i">
                    <tr class="govuk-table__row">
                        <ng-container *ngFor="let tab of tableData.tabs;">
                            <td class="govuk-table__cell" [ngStyle]="tab.width && {'width': tab.width+'%'}"
                                [innerHTML]="getDataForTable(bookingDetails,tab)"></td>
                        </ng-container>
                    </tr>
                </ng-container>
            </thead>

        </table>

    </div>
</div>